import { User, UserPayment } from '@/api/Auth/auth.interface'
import { userCharge, userPayment } from '@/api/Users/users.api'
import { message } from '@/store/modules/notifications'
import { AxiosResponse } from 'axios'
import Vue, { PropType } from 'vue'
import TransfertopUpCreditDialog from '@/components/Services/TopUps/TransfertopUpCreditDialog.vue'
import Dialog from '@/components/Dialog.vue'
import ActionButton from '@/components/ActionButton.vue'

export const transferBalanceMixin = Vue.extend({
  components: {
    appTransferTopUpCreditDialog: TransfertopUpCreditDialog,
    appDialog: Dialog,
    appActionButton: ActionButton,
  },
  props: {
    item: Object as PropType<User>,
  },
  data() {
    return {
      to: {} as User,
      transferDialog: false,
      description: '',
      as_credit: false,
      currency: 'CUP',
    }
  },
  computed: {
    from(): User {
      return this.$store.getters.profile
    },
  },
  methods: {
    async action(
      method: 'send' | 'receive',
      credit: number,
      description: string,
    ) {
      const response = await this.onSuccess({
        method: method,
        amount: credit,
        description,
        currency: this.currency,
      })
      if (response) {
        let action: (body: UserPayment) => Promise<AxiosResponse>
        const body = {
          agent: this.item.uuid,
          amount: credit,
          description: description,
          currency: this.currency,
        } as UserPayment
        if (method === 'send') {
          action = userPayment
        } else {
          action = userCharge
          // body.convert_to_credit = this.as_credit;
        }
        await action(body)
        const payload: message = {
          text: this.$t('balance-transferred'),
          title: this.$t('balance-transferred'),
          color: 'success',
          icon: 'mdi-bank-transfer',
          description: `${this.$t('transferred')} $ ${credit} ${this.$t(
            'from',
          )} ${this.from.username} ${this.$t('to')} ${this.item.username}`,
        }
        this.$store.commit('notifications/pushMessage', payload)
        this.$emit('refresh')
      }
      return response
    },
    async onSuccess(payload: {
      amount: number
      method: 'send' | 'receive'
      description?: string
      currency: string
    }) {
      if (payload.method === 'send') {
        this.item.balance =
          Number(this.item.balances[this.currency] || 0) +
          Number(payload.amount)
        return true
      } else {
        this.item.balance =
          Number(this.item.balances[this.currency] || 0) -
          Number(payload.amount)
        return true
      }
    },
  },
})
